import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";

const personService = {}
let base_url = '/collect-api/'
// 需求征集数据编辑
export function  declareRequirement(data) {
    return request({
        method: "post",
        url: `/collect/requirement/declare`,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        data: data,
        timeout:30000
    }).catch((error) => {
        this.$message.error("数据保存失败");
    });

}


/**
 * 个人常用审核意见维护-表格分页查询
 * @param {Object} data
 * @return
 */
export function getPublicPlanInfo (data) {
    return request({
        url: "/collect/plan/public-info",
        method: "get",
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        params: {
            collectId: data,
        }

    });
}

export function sendAnnoymousQuerySmsCode (principalPhone) {
    return request({
        url: "/annoymous/send-query-sms",
        method: "get",
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        params: {
            principalPhone: principalPhone,
        }

    });
}

export function query(formParam) {
    return request({
        url: "/annoymous/query",
        method: "get",
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        params: formParam,
    });
}

